module.exports = __webpack_public_path__ + "assets/img/画.527ea0c6.png";